/**
 * Infrastructure leasing — asset size tiers (list-asset pick cards & post-requirement select).
 * IDs stored in forms / payloads; titles/subs match product copy.
 */
export const INFRA_ASSET_SIZE_OPTIONS = [
  { id: 'micro', title: 'Micro', sub: 'Office supplies, hand tools, small electronics' },
  { id: 'small', title: 'Small', sub: 'Office equipment, furniture, small vehicles' },
  { id: 'medium', title: 'Medium', sub: 'Vehicles, power equipment, light construction' },
  { id: 'large', title: 'Large', sub: 'Heavy machinery, industrial equipment, fleet' },
  { id: 'macro', title: 'Macro', sub: 'Real estate, factories, infrastructure' },
  { id: 'any_size', title: 'Any Size', sub: 'Open to any scale' },
];
